import IconBase, { IconBaseProps } from "./IconBase";

const CopyIconLarge = (props: IconBaseProps) => (
  <IconBase {...props} viewBox="0 0 16 16">
    <g fill="currentColor" fillRule="nonzero">
      <path d="M6 2a1 1 0 1 1 0-2h6a4 4 0 0 1 4 4v7a1 1 0 0 1-2 0V4a2 2 0 0 0-2-2H6z" />
      <path d="M3 6a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1H3zm0-2h6a3 3 0 0 1 3 3v6a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V7a3 3 0 0 1 3-3z" />
    </g>
  </IconBase>
);

export default CopyIconLarge;
